import { render } from "./CreateBlockComponent.vue?vue&type=template&id=a9a10f36&scoped=true"
import script from "./CreateBlockComponent.vue?vue&type=script&lang=js"
export * from "./CreateBlockComponent.vue?vue&type=script&lang=js"

import "./CreateBlockComponent.vue?vue&type=style&index=0&id=a9a10f36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9a10f36"

export default script